/* eslint-disable import/no-anonymous-default-export */
import { Address } from "../../enums/checkoutShipping";
import { ShipmentType } from "../../enums/ShipmentType";
import Lineitem from "../../models/lineitem";
import addressLogic from "../address/address-logic";
import { config } from "../config";
import { formFields, vatIdProps, onChangeHandlers, onBlurHandlers, onClickHandlers } from "./formFields";
import {isValidNumberForRegion, getCountryCallingCode as getCallingCode} from 'libphonenumber-js';

declare const window: any;

const extractFormValues = (formFieldProps: any) => {
    const formValues = {};
    for(let i in formFieldProps) { 
        formValues[i] = formFieldProps[i].value;
    }
    return formValues;
}
const getTruncatedValue = function (country, eleName, elemValue, defaultMaxlength?) {
    let props = JSON.parse(JSON.stringify({ ...formFields.default.formFieldProps, ...formFields[country]?.formFieldProps }));
    const elemMaxlength = props[eleName]?.maxLength || defaultMaxlength;
    elemValue = (elemValue || "").trim();
    return elemMaxlength ? elemValue.slice(0, elemMaxlength) : elemValue;
}
const getAddressMap = () => {
    return {
        "title": "",
        "email": "email",
        "firstName": "firstName",
        "lastName": "lastName",
        "company": "company",
        "phone": "phone",
        "extension": "extension",
        "addressLine1": "streetName",
        "addressLine2": "additionalStreetInfo",
        "postalCode": "postalCode",
        "city": "city",
        "county": "state",
        "country": "country",
        "vatId" : "vatId"
    }
};

const createAddressPayload = ({ countryCode, address, type, isLoggedIn, billingAddressAgreement }: { countryCode: string, address: any, type: string, isLoggedIn: string, billingAddressAgreement?: boolean }) => {
    const country = countryCode || address.country;
    const payload: any = {
        "title": "",
        "email": getTruncatedValue(country, "email", address.email),
        "firstName": getTruncatedValue(country, "firstName", address.firstName),
        "lastName": getTruncatedValue(country, "lastName", address.lastName),
        "company": getTruncatedValue(country, "company", address.company),
        "phone": getTruncatedValue(country, "phone", address.phone),
        "streetName": getTruncatedValue(country, "addressLine1", address.addressLine1, config("ADDRESS_MAXLENGTH")),
        "additionalStreetInfo": getTruncatedValue(country, "addressLine2", address.addressLine2, config("ADDRESS_MAXLENGTH")),
        "postalCode": getTruncatedValue(country, "postalCode", address.postalCode),
        "city": getTruncatedValue(country, "city", address.city),
        "state": getTruncatedValue(country, "county", address.county),
        "country": getTruncatedValue(country, "country", address.country).toUpperCase() || config("regionCode").toUpperCase()
    };
    if (type === "SHIPPING") {
        if (isLoggedIn === "true") {
            payload.taxRegisterationNum = getTruncatedValue(country, "vatId", address.vatId);

        } else {
            payload.vatId = getTruncatedValue(country, "vatId", address.vatId);
            payload.billingAddressAgreement = billingAddressAgreement;
        }
    }
    if (isLoggedIn === 'true') {
        let telPrefix = getCountryCallingCode(country);
        let phoneNumber = `${telPrefix}${address.phone}`;
        let isValidNumber = isValidNumberForRegion(phoneNumber, country.toUpperCase());
        if (isValidNumber) {
            payload.additionalAddressInfo = JSON.stringify({ countryCallingCode: telPrefix });
        }
    }
    if (config("isNASite")) {
        payload.phone = address.phone?.replace(/[^\d]/g, '');
        payload.phone = payload.phone.substring(0, 3)+'-'+payload.phone.substring(3, 6)+'-'+payload.phone.substring(6, 10);
        payload.custom = {
            "fields": {
                "phoneExtension": getTruncatedValue(country, "extension", address.extension),
            }
        };
    }
    return payload;
}

let isAddressValid = (formFields, formState) => {
    let isAddressValid = true;
    formFields.forEach(fieldName => {
        if ((formState[fieldName]?.isRequired && formState[fieldName]?.value?.trim().length == 0) || formState[fieldName]?.highlightErrorField) {
            isAddressValid = false;
        }

        if(config('isNASite')) {
            if(fieldName === 'phone'){
                if(formState['phone']?.value.replace(/\D/g, '').length < 10 ){
                    isAddressValid = false;
                }
            }
            if(fieldName === 'postalCode'){
                const postalCode = formState['postalCode']?.value || '';
                const regex = new RegExp(formState['postalCode'].regex);
                if(!regex.test(postalCode)){
                    isAddressValid = false;
                }
            }
        }
    });
    return isAddressValid;
}

let getHighlightedErrorFieldId = (formState, shippingBillingAgreement, formFieldSequence) => {
    let highlightErrorFieldShippingArray: any = [], highlightErrorFieldBillingArray: any = [];
    formFieldSequence.forEach((fieldName) => {
        fieldName.forEach((eachFieldName) => {
            if (formState.shippingAddress[eachFieldName]?.highlightErrorField) {
                highlightErrorFieldShippingArray.push(formState.shippingAddress[eachFieldName]?.id)
            }
        })
        if (!shippingBillingAgreement) {
            fieldName.forEach((eachFieldName) => {
                if (formState.billingAddress[eachFieldName]?.highlightErrorField) {
                    highlightErrorFieldBillingArray.push(formState.billingAddress[eachFieldName]?.id)
                }
            })
        }
    })
    return {
        shippingArray: highlightErrorFieldShippingArray,
        billingArray: highlightErrorFieldBillingArray
    };
}

const scrollTohighlightErrorField = (formState, shippingBillingAgreement, formFieldSequence) => {
    let isScrollToForm : any= false;
    const highlightErrorField = getHighlightedErrorFieldId(formState, shippingBillingAgreement, formFieldSequence);
    let scrollToElement: any;
    if (highlightErrorField?.shippingArray?.length > 0)
        scrollToElement = document.getElementById(highlightErrorField.shippingArray[0]);
    else
        scrollToElement = document.getElementById(highlightErrorField.billingArray[0]);
    if (scrollToElement) {
        let topCoordinate: any = getOffset(scrollToElement).top
        window.scrollTo({ top: topCoordinate - 16, left: 0, behavior: 'smooth' });
        isScrollToForm = true
    }
    return isScrollToForm
}

const getOffset = (elem: any) => {
    const rect: any = elem.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
}

const scrollTohighlightContactPreference = () => {
    const errorBlock: any = document.getElementById('gdprErrorBlock')
    if(errorBlock){
        const contactPreBlock: any = document.getElementsByClassName('contact-preference')
        let topCoordinate: any;
        if (contactPreBlock[0]) {
            topCoordinate = getOffset(contactPreBlock[0]).top
            window.scrollTo({ top: topCoordinate - 16, left: 0, behavior: 'smooth' });
        }
    }
}

let isConatctPrefSelected = (emailAddress, subscribe) => {
    return emailAddress && subscribe !== 'N/A';
}

let isShippingAddressValid = (formState, formFields) => {
    let isShippingFormValid = true;
    formFields.forEach(fieldName => {
        if (!(fieldName === 'email') && ((formState.shippingAddress[fieldName]?.isRequired && !formState.shippingAddress[fieldName]?.value) || formState.shippingAddress[fieldName]?.highlightErrorField)) {
            isShippingFormValid = false;
        }
    });

    return isShippingFormValid;
}

const updateFormFields = (formFields: any, type, isLoggedIn) => {
    let formFieldsCopy = JSON.parse(JSON.stringify(formFields));
    formFieldsCopy.firstName.maxLength = config('nameCharLimit');
    formFieldsCopy.lastName.maxLength = config('nameCharLimit');
    formFieldsCopy.company.maxLength = config('companyCharLimit');
    if(!config('isNASite')) formFieldsCopy.phone.maxLength = 12;

    if (isLoggedIn === 'true' || type === Address.BILLING_ADDRESS) {
        delete formFieldsCopy.email;
    }
    if (type === Address.BILLING_ADDRESS) {
        formFieldsCopy = { ...formFieldsCopy, "country": { ...formFieldsCopy.country, "isDisabled": true } };
    }
    if(!config('isNASite')) {
        formFieldsCopy?.country?.listValues?.forEach((obj)=>{
            obj.name = addressLogic.getCountryTranslation(obj.value, config('locale'));
        });
    }
    return formFieldsCopy;
}
const updateFormFieldsSequence = (formFieldsSequence: any) => {
    const newFormSequence = [...formFieldsSequence];
    formFieldsSequence.forEach((element, index) => {
        if (["email"].indexOf(element[0]) !== -1) {
            delete newFormSequence[index];
        }
    });
    return newFormSequence;
}

const getAddressFieldNames = (regionCode) => {
    return JSON.parse(JSON.stringify(formFields[regionCode]?.formFieldNames ? formFields[regionCode].formFieldNames : formFields.default.formFieldNames));
}

const getAddressFieldSequence = ({ type, regionCode, isLoggedIn }) => {
    let formSequence = JSON.parse(JSON.stringify(formFields[regionCode]?.formFieldSequence ? formFields[regionCode]?.formFieldSequence : formFields.default.formFieldSequence));
    if (isLoggedIn === 'true' || type === Address.BILLING_ADDRESS) {
        formSequence = updateFormFieldsSequence(formSequence);
    }
    return formSequence;
}

const getAddressFieldProps = ({ type, mode, regionCode, defaultAddress, isLoggedIn, currentPage, editedByUser=true }: any) => {
    let newCopy = JSON.parse(JSON.stringify({ ...formFields.default.formFieldProps, ...formFields[regionCode]?.formFieldProps }));
    if (type === Address.SHIPPING_ADDRESS) {
        newCopy = { ...newCopy, vatId: {...vatIdProps} }
    }
    const map = getAddressMap();

    for (let i in newCopy) {
        let element = newCopy[i].fieldName;
        if (newCopy[i]) {
            if (i === 'country') {
                newCopy.country.value = regionCode;
            }
            if (mode === Address.NEW_FORM) {
                newCopy[i].id = type === Address.SHIPPING_ADDRESS ? `delivery-address-${element}` : `billing-address-${element}`;
            } else if (mode === Address.EDIT_FORM) {
                newCopy[i].id = type === Address.SHIPPING_ADDRESS ? `edit-delivery-address-${element}` : `edit-billing-address-${element}`;
                if (defaultAddress?.[map[i]]) {
                    if(i !== 'country') {
                        newCopy[i].value = defaultAddress[map[i]];
                        newCopy = setDefaultPOBoxError({type, regionCode, field: i , defaultAddress, map, newCopy});
                    }

                    if (!config('isNASite')){
                        if(i === 'phone'){
                            if(newCopy[i].value.replace(/\D/g, '').length > 12){
                                newCopy[i].highlightErrorField = true;
                            }
                        }
                    }
                    if (config('isNASite')){
                        if(i === 'phone'){
                            if(newCopy[i].value.replace(/\D/g, '').length < 10){
                                newCopy[i].highlightErrorField = true;
                            }
                        }
                        if(i === 'postalCode'){
                            const postalCode = newCopy[i]?.value || '';
                            const regex = new RegExp(newCopy[i].regex);
                            if(!regex.test(postalCode)){
                                newCopy[i].highlightErrorField = true;
                            }
                        }
                    }

                } else if(!editedByUser && newCopy[i].isRequired) {
                    newCopy[i].highlightErrorField = true;
                }
            }
            //Guest Retension Flow Starts
            if((isLoggedIn === 'false' && defaultAddress && i !== 'vatId') || currentPage === 'myaccount'){
                newCopy[i].value = defaultAddress[map[i]];
                // newCopy = setDefaultPOBoxError({regionCode, field: i , defaultAddress, map, newCopy}); ToDo : Is this required
            }
            // GT Flow Ends
        }
    }
    newCopy = updateFormFields(newCopy, type, isLoggedIn);
    return newCopy;
}
const getAddressOnChangeHandlers = ({ id }) => {
    return onChangeHandlers[id] || false;
}

const getAddressOnBlurHandlers = ({ id }) => {
    return onBlurHandlers[id] || false;
}

const getAddressOnClickHandlers = ({ id }) => {
    return onClickHandlers[id] || false;
}

const getCountryCallingCode = (regionCode) => {
    return `+${getCallingCode(regionCode)}`;
}

const getCountry = (address) => {
    return address?.country ? address.country : config('regionCode');
}
const retriveOldData = (oldFormData: any, newFormData: any) => {
    for (let i in newFormData) {
        if (typeof newFormData[i] === "object" && ['country', 'vatId'].indexOf(i) === -1) {
            newFormData[i].value = oldFormData[i].value;
        }
    }
    return newFormData;
}
const createExemptTaxActions = (cartData, currentSelectedCountry, isLoggedIn) => {
    const taxRateActions: any = [];
    Object.keys(cartData?.lineItems).forEach(lineItemId => {
        let element = cartData.lineItems[lineItemId][0].data;
        taxRateActions.push({
            'action': 'setLineItemTaxRate',
            'lineItemId': element.id,
            'externalTaxRate': {
                'name': element.taxRateWithName.name,
                'amount': 0,
                'country': element.taxRateWithName.country || currentSelectedCountry
            }
        });
        if(isLoggedIn === 'true') {
            taxRateActions.push({
                'action': 'setLineItemCustomField',
                'lineItemId': element.id,
                'name': 'externalTaxRateDraft',
                'value': JSON.stringify(element.taxRateWithName)
            });
        }
        element.customLineItems.forEach(element => {
            taxRateActions.push({
                'action': 'setCustomLineItemTaxRate',
                'customLineItemId': element.id,
                'externalTaxRate': {
                    'name': element.taxRate.name,
                    'amount': 0,
                    'country': element.taxRate.country || currentSelectedCountry
                }
            });
        });
    });
    return taxRateActions;
}
const createNonExemptTaxRateActions = (cartData) => {
    const taxRateActions: any = [];
    Object.keys(cartData?.lineItems).forEach(lineItemId => {
        let element = cartData.lineItems[lineItemId][0].data;
        taxRateActions.push({
            "action": "setLineItemTaxRate",
            "lineItemId": element.id,
            "externalTaxRate": {
                "name": element.taxRateWithName.name,
                "amount": element.taxRateWithName.amount,
                "country": element.taxRateWithName.country
            }
        });
        element?.customLineItems.forEach(customElement => {
            if (customElement.custom?.fields?.customLineItemType === 'usbcharge') {
                taxRateActions.push({
                    action: "changeCustomLineItemMoney",
                    customLineItemId: customElement.id,
                    money: customElement.money
                });
            }
            taxRateActions.push({
                "action": "setCustomLineItemTaxRate",
                "customLineItemId": customElement.id,
                "externalTaxRate": {
                    "name": customElement.taxRate.name,
                    "amount": customElement.taxRate.amount,
                    "country": customElement.taxRate.country
                }
            });
        });
    });

    taxRateActions.push({
        "action": "recalculate",
        "updateProductData": false
    });
    return taxRateActions;
}
const createAddressMap = (suggestedAdress) => {
    const obj = {};
    const addressMap = {
        'Line1': 'addressLine1',
        'Line2': 'addressLine2',
        'PostalCode': 'postalCode',
        'City': 'city',
        'Province': 'county',
        'CountryIso2': 'country'
    }
    for (let prop in addressMap) {
        obj[addressMap[prop]] = suggestedAdress[prop];
    }
    return obj;
}
const createUpdatedAdressState = ({ prevState, obj, type }) => {
    const map = {};
    const addressItems = ['addressLine1', 'addressLine2', 'postalCode', 'city', 'county', 'country'];
    addressItems.forEach((field) => {
        map[field] = {
            ...prevState[type][field], value: obj[field]
        }
    });
    return map;
}

const getShippingBillingAddress = (addressForm, shippingBillingAgreement, isLoggedIn, email?) => {
    let shippingData : any = extractFormValues(addressForm.shippingAddress);
    shippingData = createAddressPayload({ countryCode: addressForm.shippingAddress.country.value, address: shippingData, type: 'SHIPPING', isLoggedIn: isLoggedIn, billingAddressAgreement: shippingBillingAgreement });
    let billingData : any = {};

    if (shippingBillingAgreement) {
        billingData = shippingData;
    } else {
        billingData = extractFormValues(addressForm.billingAddress);
        billingData = createAddressPayload({ countryCode: addressForm.billingAddress.country.value, address: billingData, type: 'BILLING', isLoggedIn: isLoggedIn });
    }
    if(isLoggedIn === 'true') {
        shippingData.email = email;
        billingData.email = email;
    }
    else{
        billingData.email = shippingData.email;
    }
    return {
        shippingData : shippingData,
        billingData : billingData
    }
    
} 
const getShippingBillingAddressMyAccount = (addressForm, type, isLoggedIn, email? ) => {
    let billingData : any = {};
    let shippingData : any = {};
    if(type === Address.SHIPPING_ADDRESS ){
        shippingData = extractFormValues(addressForm.shippingAddress);
        shippingData = createAddressPayload({ countryCode: addressForm.shippingAddress.country.value, address: shippingData, type: 'SHIPPING', isLoggedIn: isLoggedIn, billingAddressAgreement: false });
    }
    else{
        billingData = extractFormValues(addressForm.billingAddress);
        billingData = createAddressPayload({ countryCode: addressForm.billingAddress.country.value, address: billingData, type: 'BILLING', isLoggedIn: isLoggedIn });
    }

    if(isLoggedIn === 'true') {
        shippingData.email = email;
        billingData.email = email;
    }
    return {
        shippingData : shippingData,
        billingData : billingData
    }
} 

const getDefaultShippingMethod = (cart, shippingMethods, shippingAddressState) => {
    const defaultShippingType = shippingMethods[0];
    if (cart?.shippingType && cart.shippingType !== defaultShippingType) {
        if (!cart?.isCartHazardous) {
            const shipMethod = shippingMethods.find(
                (method) =>
                    method.key === cart.shippingType ||
                    method?.displayName === cart?.shippingType
            );
            if (isStateSupported(shipMethod, shippingAddressState)) {
                return shipMethod;
            }
        }
    }
    return defaultShippingType;
};

const isStateSupported = (method, shippingAddressState) => {
    if(shippingAddressState === '') return true;
    return !method?.nonSupportedStates.split(",").includes(shippingAddressState);
};
const showHidePOBoxWarning = ({ value, type, addressLine, setAddressFormCall }) => {
    let stateUpdate = {
        showMsg: false,
        highlightErrorField: false,
        isPoBoxWarningActive: false,
    };
    if (isPoBoxText(value)) {
        stateUpdate = {
            showMsg: true,
            highlightErrorField: true,
            isPoBoxWarningActive: true,
        };
    }
    setAddressFormCall({
        type, modifyStateCallback: (prevState) => {
            return {
                [addressLine]: {
                    ...prevState[type][addressLine],
                    ...stateUpdate
                }
            }
        }
    });
}

const setDefaultPOBoxError = ({type, regionCode, field, defaultAddress, map, newCopy}) => {
    if (type === Address.SHIPPING_ADDRESS && regionCode === 'US' && (field === 'addressLine1' || field === 'addressLine2')) {
        if (isPoBoxText(defaultAddress[map[field]])) {
            newCopy[field].showMsg = true;
            newCopy[field].highlightErrorField = true;
        }
    }
    return newCopy;
}
const isPoBoxText = (streetNameText) => {
    const poBoxTexts = ['po box', 'p.o. box', 'p o box'];
    for (let i = 0; i < poBoxTexts.length; i++) {
        if (streetNameText?.toLowerCase().indexOf(poBoxTexts[i]) !== -1) {
            return true;
        }
    }
    return false;
}
const checkAndHighlightRequiredFields = (formFields, prevState, type) => {
    formFields.forEach(fieldName => {
        if (prevState[type][fieldName]?.isRequired && prevState[type][fieldName]?.value?.trim().length == 0) {
            prevState = highlightedErrorFields(prevState, type, fieldName);
        }
        if (config('isNASite')){
            if(fieldName === 'phone'){
                if(prevState[type][fieldName]?.value.replace(/\D/g, '').length < 10){
                    prevState = highlightedErrorFields(prevState, type, fieldName);
                }
            }
            if(fieldName === 'postalCode') {
                const postalCode = prevState[type][fieldName]?.value || '';
                const regex = new RegExp(prevState[type][fieldName]?.regex);
                if(!regex.test(postalCode)){
                    prevState = highlightedErrorFields(prevState, type, fieldName);
                }
            }
        }
    });
    return prevState;
}

const highlightedErrorFields = (prevState, type, fieldName) => {
    return {
        ...prevState,
        [type]: {
            ...prevState[type],
            [fieldName]: {
                ...prevState[type][fieldName],
                'highlightErrorField': true
            }
        }
    };
}
const updateCustomerFeedInfo = (customerFeedInfo) => {
    const map = {
        "address1" : "streetName",
        "address2" : "additionalStreetInfo",
        "postCode" : "postalCode",
        "province" : "state",
        "emailAddress" : "email"
    };
    for (let key in map) {
        customerFeedInfo[map[key]] = customerFeedInfo[key];
    }
    return customerFeedInfo;
}
const isBrowserAutoFill = (target) => {
    return navigator.userAgent.match(/chrome/i)  && target?.matches(':-internal-autofill-selected');
}

const getShippingCategoryFromCart = (cart) => {
    let shippingCategory: string = '';
    Object.values(cart.lineItems as Lineitem).some(lineItem=> {
        const lineitemShipCategory = lineItem[0]?.data?.shipCategory || ShipmentType.LIGHT;
        if (lineitemShipCategory === ShipmentType.HEAVY) {
            shippingCategory = lineitemShipCategory;
            return true; // Stop iteration when HEAVY is found
        }
        if (lineitemShipCategory === ShipmentType.LIGHT) {
            shippingCategory = lineitemShipCategory;
        }
        if (lineitemShipCategory === ShipmentType.APPAREL && !shippingCategory) {
            shippingCategory = lineitemShipCategory; // Only setting apparel if shippingCategory is empty.
        }        
        return false; // Continue iterating for heavier/light categories
    })

    return shippingCategory || ShipmentType.LIGHT; // Return default if no category is found
}

export default {
    extractFormValues,
    getAddressFieldNames,
    getAddressFieldSequence,
    getAddressFieldProps,
    getCountry,
    getAddressOnChangeHandlers,
    getAddressOnBlurHandlers,
    getAddressOnClickHandlers,
    retriveOldData,
    isAddressValid,
    isShippingAddressValid,
    isConatctPrefSelected,
    getCountryCallingCode,
    createAddressPayload,
    createExemptTaxActions,
    createNonExemptTaxRateActions,
    createAddressMap,
    createUpdatedAdressState,
    getDefaultShippingMethod,
    isStateSupported,
    scrollTohighlightErrorField,
    scrollTohighlightContactPreference,
    getShippingBillingAddress,
    showHidePOBoxWarning,
    isPoBoxText,
    checkAndHighlightRequiredFields,
    updateCustomerFeedInfo,
    isBrowserAutoFill,
    getShippingCategoryFromCart,
    getShippingBillingAddressMyAccount
}